<template>
  <main class="page-projects page-new-project">
    <PageTitleContainer>
      <PageTitle removeMargin>Nuovo progetto</PageTitle>

      <div class="text-right mb-3">
          <router-link class="btn btn-outline-secondary" :to="{ name: 'projects.list' }">Indietro</router-link>
      </div>
    </PageTitleContainer>
    <div class="container">
      <ProjectForm :feedback.sync="feedback" @submitForm="submit" />
    </div>
  </main>
</template>

<script>

export default {
  name: 'project-new',
  components: {
    PageTitle: () => import('@/views/components/Layout/PageTitle'),
    PageTitleContainer: () => import('@/views/components/Layout/PageTitleContainer'),
    ProjectForm: () => import('@/views/components/Form/ProjectForm'),
  },
  data () {
    return {
      feedback: null,
    };
  },
  methods: {
    submit (projectForm) {
      const project = { ...projectForm };

      this.$api.createProject(project)
        .then(res => {
          this.feedback = true;
          this.$router.push({ name: 'projects.show', params: { id: res.data.id } });
        })
        .catch(err => {
          this.feedback = false;
          this.$log.error(err);
        })
      ;
    },
  },
};

</script>
